const StatementModule = () => import(/* webpackChunkName: "profile-module" */ './views/Module.vue');
const MyBets = () => import(/* webpackChunkName: "profile" */ './views/MyBets.vue');
const ProfitLoss = () => import(/* webpackChunkName: "profile" */ './views/ProfitLoss.vue');
const ProfitLossDetail = () => import(/* webpackChunkName: "profit-loss" */ './views/ProfitLossDetail.vue');
const AccountStatement = () => import(/* webpackChunkName: "profile" */ './views/AccountStatement.vue');
const MatchMarket = () => import(/* webpackChunkName: "match-market" */ './views/MatchMarket.vue');
const DepositWithdrawlStatement = () => import(/* webpackChunkName: "match-market" */ './views/DepositWithdrawlStatement.vue');

const ProfileRoutes = {
    path: '/',
    component: StatementModule,
    children: [
        {
            path: 'my-bets',
            name: 'my-bets',
            component: MyBets,
            meta: {
                title: 'My Bets',
              },
        },
        {
            path: 'profit-loss',
            name: 'profit-loss',
            component: ProfitLoss,
            meta: {
                title: 'Profit Loss',
              },
        },
        {
            path: '/account-statement/:type',
            name: 'account-statement',
            component: AccountStatement,
            meta: {
                title: 'Account Statement',
            },
            beforeEnter: (to, from, next) => {
                const validTypes = ['1', '2', '3'];
                if (validTypes.includes(to.params.type)) {
                    next();
                } else {
                    next('/not-found');
                }
            }
        },
        {
            path: '/deposit-withdrwal-statement',
            name: 'deposit-withdrwal-statement',
            component: DepositWithdrawlStatement,
            meta: {
                title: 'Deposit Withdrawl Statement',
              },
        },
        {
            path: 'match-market/:item/:type',
            name: 'match-market',
            component: MatchMarket,
            meta: {
                title: 'Open Bets Details'
            }
        },
        {
        path: 'profit-loss-detail',
        name: 'profitLossDetail',
        component: ProfitLossDetail
      },
    ],
}   

export default ProfileRoutes;